export const productCtasColors = {
  PRIMARY_BLUE: 'primaryBlue',
  SECONDARY_BLUE: 'secondaryBlue',
  PRIMARY_GREEN: 'primaryGreen',
  SECONDARY_GREEN: 'secondaryGreen',
} as const;

export const MAX_CTA_LIMIT = 3;

export const ADDITIONAL_CTA_LINKS = 'addition-links';

export const NUMBER_OF_BUTTONS_BEFORE = 3;

export const productCtasButtonType = {
  CART: 'cart',
  FAVORITES: 'favorites',
  COMPARE: 'compare',
} as const;

export const productCtas = {
  buttons: {
    [productCtasButtonType.CART]: {
      isShown: true,
      list: [],
      color: productCtasColors.PRIMARY_BLUE,
      icons: {
        addIcon: 'segment_retail',
        disableIconInPdpCtaBlock: true,
      },
      dataset: {
        daElementId: 'add_p',
      },
      labels: {},
    },
    [productCtasButtonType.FAVORITES]: {
      isShown: false,
      list: [],
      color: productCtasColors.SECONDARY_BLUE,
      icons: {
        addIcon: 'star_stroke',
        removeIcon: 'star_plain',
      },
      dataset: {
        daElementId: 'add_p',
      },
      labels: {},
    },
  },
  productProp: 'repositoryId',
};
